import { Injectable } from '@angular/core';
import { EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';

import { SpecificationCategory } from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

export type SpecificationCategoryModel = getEntityType<SpecificationCategoryState>;

export type SpecificationCategoryState = EntityState<
  Omit<RequireSome<Partial<SpecificationCategory>, 'id'>, 'specifications'> & {
    specifications: string[];
  }
>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'specification-category' })
export class SpecificationCategoryStore extends EntityStore<SpecificationCategoryState> {
  constructor() {
    super({});
  }
}
